import { gql } from "@apollo/client";

export const GET_SERVICE_REQUEST_QUESTIONS = gql`
  query ServiceRequestQuestions($flow: String, $serviceType: String, $serviceCategory: String, $branchId: String) {
    serviceRequestQuestions(flow: $flow, serviceType: $serviceType, serviceCategory: $serviceCategory, branchId: $branchId) {
      id
      question
      flow
      isActive
      answerType
      options
      isMandatory
      requestTypes
      serviceCategories
      helpText
      index
    }
  }
`;

